<template>
    <div class="card cursor-zoom-in lg:w-[560px] w-auto lg:h-[314px] h-auto border border-gray-300 relative overflow-hidden" width="560px" height="314px" @mouseenter="onMouseEnter" 
    @mouseleave="onMouseLeave">
        <Galleria
            ref="galleria"
            v-model:activeIndex="activeIndex"
            :value="formattedImages"
            :numVisible="5"
            containerStyle="max-width: 640px overflow-hidden"
            :showThumbnails="showThumbnails"
            :showItemNavigators="true"
            :showItemNavigatorsOnHover="true"
            :circular="true"
            :autoPlay="isAutoPlay"
            :transitionInterval="4000"
            :responsiveOptions="responsiveOptions"
            :pt="{
            root: {
                class: [{ 'flex flex-col': fullScreen }]
            },
            content: {
                class: ['relative', { 'flex-1 justify-center': fullScreen }]
            },
            thumbnails: 'absolute w-full left-0 bottom-0',
            footer: { 
                class: [
                    'absolute bottom-0 w-full transition-all duration-300 rounded-none',
                    {'opacity-0': !isHovering && !fullScreen, 'opacity-100': isHovering || fullScreen}
                ] 
                },
                thumbnailContainer: {
                class: 'rounded-none'
                }
            }"
        >
            <template #item="slotProps">
                <img 
                    :src="slotProps.item.itemImageSrc" 
                    :alt="slotProps.item.alt" 
                    @click="toggleFullScreen"
                    class="max-w-full overflow-hidden"
                    :style="{ maxHeight: '560px', objectFit: 'contain', }"
                />
            </template>
            <template #thumbnail="slotProps">
            <div class="grid gap-4 justify-center">
                <img 
                :src="slotProps.item.thumbnailImageSrc" 
                :alt="slotProps.item.alt" 
                class="w-16 h-16 object-cover object-center rounded-none"
                />
            </div>
            </template>
            <template #footer >
                <div class="flex items-stretch bg-surface-950 text-white h-10">
                    <button 
                    type="button" 
                    @click="onThumbnailButtonClick" 
                    class="bg-transparent border-none rounded-none hover:bg-white/10 text-white inline-flex justify-center items-center cursor-pointer px-3"
                    >
                        <i class="pi pi-th-large"></i>
                    </button>
                    <button 
                    type="button" 
                    @click="toggleAutoSlide" 
                    class="bg-transparent border-none rounded-none hover:bg-white/10 text-white inline-flex justify-center items-center cursor-pointer px-3"
                    >
                        <i :class="slideButtonIcon"></i>
                    </button>
                    <span v-if="formattedImages" class="flex items-center gap-4 ml-3">
                        <span class="text-sm">{{ activeIndex + 1 }}/{{ formattedImages.length }}</span>
                        <span class="font-bold text-sm">{{ formattedImages[activeIndex].title }}</span>
                        <span class="text-sm">{{ formattedImages[activeIndex].alt }}</span>
                    </span>
                    <button 
                    type="button" 
                    @click="toggleFullScreen" 
                    class="bg-transparent border-none rounded-none hover:bg-white/10 text-white inline-flex justify-center items-center cursor-pointer px-3 ml-auto"
                    >
                        <i :class="fullScreenIcon"></i>
                    </button>
                </div>
            </template>
        </Galleria>
    </div>
</template>
  
  <script setup>
  // @ts-ignore
  import { ref, computed, onMounted, onUnmounted } from "vue";
  // @ts-ignore
  import Galleria from 'primevue/galleria';
  
  // Configuración de imágenes
  const carouselItems = Array.from({ length: 22 }, (_, i) => ({
    image: `/pagesImages/Presentaciones/B01C01/B01 C01 Leonardo Moreno LDerecho Presentacion-${String(i + 1).padStart(2, "0")}.webp`,
    alt: `Imagen ${i + 1}`,
    title: `Presentación`
  }));
  
  // Formateamos las imágenes para que coincidan con la estructura que espera Galleria
  // @ts-ignore
  const formattedImages = computed(() => {
    return carouselItems.map(item => ({
      itemImageSrc: item.image,
      thumbnailImageSrc: item.image,
      alt: item.alt,
      title: item.title
    }));
  });
  
    // Lógica de la galería
    const galleria = ref();
    // @ts-ignore
    const activeIndex = ref(0);
    const showThumbnails = ref(false);
    const fullScreen = ref(false);
    const isAutoPlay = ref(true);

    const isHovering = ref(false);

    const onMouseEnter = () => {
    isHovering.value = true;
    };

    const onMouseLeave = () => {
    isHovering.value = false;
    };
  
  // @ts-ignore
  const toggleAutoSlide = () => {
    isAutoPlay.value = !isAutoPlay.value;
  };
  
  // @ts-ignore
  const onThumbnailButtonClick = () => {
    showThumbnails.value = !showThumbnails.value;
  };
  
  // @ts-ignore
  const responsiveOptions = ref([
    {
      breakpoint: '1300px',
      numVisible: 4
    },
    {
      breakpoint: '768px',
      numVisible: 3
    },
    {
      breakpoint: '575px',
      numVisible: 1
    }
  ]);
  
  // Funciones para pantalla completa
  // @ts-ignore
  const toggleFullScreen = () => {
    if (fullScreen.value) {
      closeFullScreen();
    } else {
      openFullScreen();
    }
  };
  
  const onFullScreenChange = () => {
    fullScreen.value = !fullScreen.value;
  };
  
  const openFullScreen = () => {
    let elem = galleria.value.$el;
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    }
  };
  
  const closeFullScreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    // @ts-ignore
    } else if (document.mozCancelFullScreen) {
      // @ts-ignore
      document.mozCancelFullScreen();
    // @ts-ignore
    } else if (document.webkitExitFullscreen) {
      // @ts-ignore
      document.webkitExitFullscreen();
    // @ts-ignore
    } else if (document.msExitFullscreen) {
      // @ts-ignore
      document.msExitFullscreen();
    }
  };
  
  const bindDocumentListeners = () => {
    document.addEventListener('fullscreenchange', onFullScreenChange);
    document.addEventListener('mozfullscreenchange', onFullScreenChange);
    document.addEventListener('webkitfullscreenchange', onFullScreenChange);
    document.addEventListener('msfullscreenchange', onFullScreenChange);
  };
  
  const unbindDocumentListeners = () => {
    document.removeEventListener('fullscreenchange', onFullScreenChange);
    document.removeEventListener('mozfullscreenchange', onFullScreenChange);
    document.removeEventListener('webkitfullscreenchange', onFullScreenChange);
    document.removeEventListener('msfullscreenchange', onFullScreenChange);
  };
  
  // Computed properties
  // @ts-ignore
  const fullScreenIcon = computed(() => {
    return `pi ${fullScreen.value ? 'pi-window-minimize' : 'pi-window-maximize'}`;
  });
  
  // @ts-ignore
  const slideButtonIcon = computed(() => {
    return `pi ${isAutoPlay.value ? 'pi-pause' : 'pi-play'}`;
  });
  
  // Hooks del ciclo de vida
  onMounted(() => {
    bindDocumentListeners();
  });
  
  onUnmounted(() => {
    unbindDocumentListeners();
  });
  </script>
  
  <style scoped>
  .card {
    max-width: 640px;
    width: 100%;
    padding: 0;
  }

  /* Controles de navegación (flechas) */
  :deep(.p-galleria-item-nav) {
    background: rgba(59, 121, 59, 0.7) !important; /* Verde con transparencia */
    color: white !important;
    border-radius: 50%;
    width: 2.5rem;
    height: 2.5rem;
    transition: all 0.3s ease;
  }
  
  :deep(.p-galleria-item-nav:hover) {
    background: rgba(39, 101, 39, 0.9) !important; /* Verde más oscuro al hover */
    transform: scale(1.1);
  }
  
  /* Iconos dentro de las flechas */
  :deep(.p-galleria-item-nav i) {
    color: gray !important;
    font-size: 1.2rem;
  }
  
  /* Barra inferior de controles */
  :deep(.p-galleria-footer) {
    background: #999999 !important; /* Azul oscuro - puedes cambiarlo */
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  /* Botones en el footer */
  :deep(.p-galleria-footer button) {
    color: #ecf0f1 !important; /* Color de texto claro */
    transition: all 0.3s ease;
  }
  
  :deep(.p-galleria-footer button:hover) {
    background: rgba(255, 255, 255, 0.1) !important;
    color: #ecf0f1 !important; /* Verde para hover */
  }
  
  /* Texto en el footer */
  :deep(.p-galleria-footer span) {
    color: #ecf0f1 !important; /* Color de texto claro */
  }
  
  /* Thumbnails */
  :deep(.p-galleria-thumbnail-container) {
    background: rgba(44, 62, 80, 0.9) !important; /* Mismo que el footer */
    padding: 1rem;
  }
  
  :deep(.p-galleria-thumbnail-item) {
    border: 2px solid transparent;
    transition: all 0.3s ease;
  }
  
  :deep(.p-galleria-thumbnail-item:hover),
  :deep(.p-galleria-thumbnail-item.p-highlight) {
    border-color: #2ecc71; /* Verde para el thumbnail activo/hover */
    opacity: 1;
    transform: scale(1.05);
  }
  
  /* Indicador de imagen activa */
  :deep(.p-galleria-indicators .p-highlight button) {
    background: #2ecc71 !important; /* Verde para el indicador activo */
  }

  /* Eliminar bordes y esquinas redondeadas en todos los elementos */
:deep(.p-galleria),
:deep(.p-galleria-content),
:deep(.p-galleria-item),
:deep(.p-galleria-item-wrapper),
:deep(.p-galleria-item-container),
:deep(.p-galleria-thumbnail-container),
:deep(.p-galleria-thumbnail-item),
:deep(.p-galleria-thumbnail-items),
:deep(.p-galleria-footer) {
  border: none !important;
  border-radius: 0 !important;
}

/* Estilos para la transición suave del footer */
:deep(.p-galleria-footer) {
  transition: opacity 0.3s ease, transform 0.3s ease;
  transform: translateY(100%);
}

.card:hover :deep(.p-galleria-footer),
:deep(.p-galleria.p-galleria-fullscreen .p-galleria-footer) {
  opacity: 1;
  transform: translateY(0);
}

/* Asegurar que no haya bordes en las miniaturas */
:deep(.p-galleria-thumbnail-item) {
  border: none !important;
}
  </style>